import { useState } from "react";

export default function Avatar({ name = "", userId, avatarPath, size = "h-9 w-9", textSize = "text-sm", testId }) {
  const [err, setErr] = useState(false);
  if (avatarPath && userId && !err) {
    return (
      <img
        src={`${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}/avatar?v=${encodeURIComponent(avatarPath)}`}
        alt={name}
        onError={() => setErr(true)}
        data-testid={testId}
        className={`${size} rounded-sm object-cover aspect-square border border-slate-200`}
      />
    );
  }
  return (
    <div
      data-testid={testId}
      className={`${size} aspect-square rounded-sm bg-primary text-white flex items-center justify-center font-bold ${textSize}`}
    >
      {name?.charAt(0)?.toUpperCase() || "?"}
    </div>
  );
}
